import { render, staticRenderFns } from "./VideoLearningSmart.vue?vue&type=template&id=08fab10a&scoped=true&"
import script from "./VideoLearningSmart.vue?vue&type=script&lang=ts&"
export * from "./VideoLearningSmart.vue?vue&type=script&lang=ts&"
import style0 from "./VideoLearningSmart.vue?vue&type=style&index=0&id=08fab10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fab10a",
  null
  
)

export default component.exports